import React from 'react';
import { GetServerSideProps } from 'next';
import getConfig from 'next/config';
import BasicLayout from 'layout/Basic';
import EventDetails, { Props } from 'containers/Events/Details';
import { convertProps } from 'lib/parseAPIResponse';
import { NextSeo } from 'next-seo';

export const GalleryDetailsPage = (props: Props): React.JSX.Element => {
    const { url } = getConfig().publicRuntimeConfig;

    const description =
        props.event.seoDescription || props.event.description?.replace(/<[^>]*>?/gm, '');

    return (
        <BasicLayout ads={props.ads}>
            <NextSeo
                title={props.event.seoTitle || props.event.name}
                canonical={`${url}/wydarzenia/${props.event.seoSlug}`}
                description={description}
                openGraph={{
                    title: props.event.name,
                    description: description,
                    url: `${url}/wydarzenia/${props.event.seoSlug}`
                }}
            />
            <EventDetails {...props} />
        </BasicLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const slug = params.slug;
    const { apiUrl } = getConfig().publicRuntimeConfig;
    return Promise.all([
        fetch(`${apiUrl}/public/api/events/${slug}`),
        fetch(`${apiUrl}/public/api/naszadsik?path=events/${slug}`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
};

export default GalleryDetailsPage;
